/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangLayoutRouteImport } from './routes/$lang/_layout'
import { Route as LangLayoutAuthLoginRouteImport } from './routes/$lang/_layout/auth/login'
import { Route as LangLayoutAuthRedirectRouteImport } from './routes/$lang/_layout/auth/redirect'
import { Route as LangLayoutAuthResetPasswordRouteImport } from './routes/$lang/_layout/auth/reset-password'
import { Route as LangLayoutOrgsOrgLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout'
import { Route as LangLayoutOrgsOrgLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutAnalyticsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/analytics'
import { Route as LangLayoutOrgsOrgLayoutInternalRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal'
import { Route as LangLayoutOrgsOrgLayoutOutboundRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound'
import { Route as LangLayoutOrgsOrgLayoutInternalIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/index'
import { Route as LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/index'
import { Route as LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRouteImport } from './routes/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangIndexRoute = LangIndexRouteImport.update({
  id: '/$lang/',
  path: '/$lang/',
  getParentRoute: () => rootRouteImport,
} as any)
const LangLayoutRoute = LangLayoutRouteImport.update({
  id: '/$lang/_layout',
  path: '/$lang',
  getParentRoute: () => rootRouteImport,
} as any)
const LangLayoutAuthLoginRoute = LangLayoutAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => LangLayoutRoute,
} as any)
const LangLayoutAuthRedirectRoute = LangLayoutAuthRedirectRouteImport.update({
  id: '/auth/redirect',
  path: '/auth/redirect',
  getParentRoute: () => LangLayoutRoute,
} as any)
const LangLayoutAuthResetPasswordRoute =
  LangLayoutAuthResetPasswordRouteImport.update({
    id: '/auth/reset-password',
    path: '/auth/reset-password',
    getParentRoute: () => LangLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutRoute = LangLayoutOrgsOrgLayoutRouteImport.update({
  id: '/orgs/$org/_layout',
  path: '/orgs/$org',
  getParentRoute: () => LangLayoutRoute,
} as any)
const LangLayoutOrgsOrgLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutAnalyticsRoute =
  LangLayoutOrgsOrgLayoutAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalRoute =
  LangLayoutOrgsOrgLayoutInternalRouteImport.update({
    id: '/internal',
    path: '/internal',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundRoute =
  LangLayoutOrgsOrgLayoutOutboundRouteImport.update({
    id: '/outbound',
    path: '/outbound',
    getParentRoute: () => LangLayoutOrgsOrgLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalIndexRoute =
  LangLayoutOrgsOrgLayoutInternalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteImport.update({
    id: '/whs/$location/_layout',
    path: '/whs/$location',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteImport.update({
    id: '/whs/$location/_layout',
    path: '/whs/$location',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRouteImport.update({
    id: '/ftp',
    path: '/ftp',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRouteImport.update({
    id: '/ftp-config',
    path: '/ftp-config',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRouteImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRouteImport.update({
    id: '/locations',
    path: '/locations',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRouteImport.update({
    id: '/selectors',
    path: '/selectors',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRouteImport.update({
    id: '/user-groups',
    path: '/user-groups',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRouteImport.update({
    id: '/zones',
    path: '/zones',
    getParentRoute: () => LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
  } as any)
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRouteImport.update(
    {
      id: '/selector-sessions/',
      path: '/selector-sessions/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRouteImport.update(
    {
      id: '/task-plans/',
      path: '/task-plans/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteImport.update(
    {
      id: '/tasks/_layout',
      path: '/tasks',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRouteImport.update(
    {
      id: '/selector-tasks/$selectorId/',
      path: '/selector-tasks/$selectorId/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRouteImport.update(
    {
      id: '/task-plans/$task-plan/',
      path: '/task-plans/$task-plan/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRouteImport.update(
    {
      id: '/task-plans/load-plans/',
      path: '/task-plans/load-plans/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRouteImport.update(
    {
      id: '/webhooks/endpoints/',
      path: '/webhooks/endpoints/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRouteImport.update(
    {
      id: '/webhooks/endpoints/new',
      path: '/webhooks/endpoints/new',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRouteImport.update(
    {
      id: '/task-plans/$task-plan/$task/',
      path: '/task-plans/$task-plan/$task/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRouteImport.update(
    {
      id: '/task-plans/$task-plan/simulate/',
      path: '/task-plans/$task-plan/simulate/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRouteImport.update(
    {
      id: '/webhooks/endpoints/$endpoint/deliveries',
      path: '/webhooks/endpoints/$endpoint/deliveries',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRouteImport.update(
    {
      id: '/all/',
      path: '/all/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute,
    } as any,
  )
const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRouteImport.update(
    {
      id: '/plans/',
      path: '/plans/',
      getParentRoute: () =>
        LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$lang': typeof LangLayoutRouteWithChildren
  '/$lang/': typeof LangIndexRoute
  '/$lang/auth/login': typeof LangLayoutAuthLoginRoute
  '/$lang/auth/redirect': typeof LangLayoutAuthRedirectRoute
  '/$lang/auth/reset-password': typeof LangLayoutAuthResetPasswordRoute
  '/$lang/orgs/$org': typeof LangLayoutOrgsOrgLayoutRouteWithChildren
  '/$lang/orgs/$org/analytics': typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  '/$lang/orgs/$org/internal': typeof LangLayoutOrgsOrgLayoutInternalRouteWithChildren
  '/$lang/orgs/$org/outbound': typeof LangLayoutOrgsOrgLayoutOutboundRouteWithChildren
  '/$lang/orgs/$org/': typeof LangLayoutOrgsOrgLayoutIndexRoute
  '/$lang/orgs/$org/internal/': typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  '/$lang/orgs/$org/outbound/': typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  '/$lang/orgs/$org/internal/whs/$location': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren
  '/$lang/orgs/$org/outbound/whs/$location': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren
  '/$lang/orgs/$org/internal/whs/$location/ftp': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp-config': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  '/$lang/orgs/$org/internal/whs/$location/home': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  '/$lang/orgs/$org/outbound/whs/$location/items': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  '/$lang/orgs/$org/outbound/whs/$location/locations': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  '/$lang/orgs/$org/outbound/whs/$location/selectors': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  '/$lang/orgs/$org/outbound/whs/$location/user-groups': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  '/$lang/orgs/$org/outbound/whs/$location/zones': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  '/$lang/orgs/$org/internal/whs/$location/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren
  '/$lang/orgs/$org/internal/whs/$location/selector-sessions/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/all/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/plans/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$lang': typeof LangIndexRoute
  '/$lang/auth/login': typeof LangLayoutAuthLoginRoute
  '/$lang/auth/redirect': typeof LangLayoutAuthRedirectRoute
  '/$lang/auth/reset-password': typeof LangLayoutAuthResetPasswordRoute
  '/$lang/orgs/$org/analytics': typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  '/$lang/orgs/$org': typeof LangLayoutOrgsOrgLayoutIndexRoute
  '/$lang/orgs/$org/internal': typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  '/$lang/orgs/$org/outbound': typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  '/$lang/orgs/$org/internal/whs/$location/ftp-config': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  '/$lang/orgs/$org/internal/whs/$location/home': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  '/$lang/orgs/$org/outbound/whs/$location/items': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  '/$lang/orgs/$org/outbound/whs/$location/locations': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  '/$lang/orgs/$org/outbound/whs/$location/selectors': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  '/$lang/orgs/$org/outbound/whs/$location/user-groups': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  '/$lang/orgs/$org/outbound/whs/$location/zones': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  '/$lang/orgs/$org/internal/whs/$location': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/selector-sessions': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/all': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  '/$lang/orgs/$org/outbound/whs/$location/tasks/plans': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$lang/_layout': typeof LangLayoutRouteWithChildren
  '/$lang/': typeof LangIndexRoute
  '/$lang/_layout/auth/login': typeof LangLayoutAuthLoginRoute
  '/$lang/_layout/auth/redirect': typeof LangLayoutAuthRedirectRoute
  '/$lang/_layout/auth/reset-password': typeof LangLayoutAuthResetPasswordRoute
  '/$lang/_layout/orgs/$org/_layout': typeof LangLayoutOrgsOrgLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/analytics': typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  '/$lang/_layout/orgs/$org/_layout/internal': typeof LangLayoutOrgsOrgLayoutInternalRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/outbound': typeof LangLayoutOrgsOrgLayoutOutboundRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/': typeof LangLayoutOrgsOrgLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/': typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/': typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/': typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/': typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$lang'
    | '/$lang/'
    | '/$lang/auth/login'
    | '/$lang/auth/redirect'
    | '/$lang/auth/reset-password'
    | '/$lang/orgs/$org'
    | '/$lang/orgs/$org/analytics'
    | '/$lang/orgs/$org/internal'
    | '/$lang/orgs/$org/outbound'
    | '/$lang/orgs/$org/'
    | '/$lang/orgs/$org/internal/'
    | '/$lang/orgs/$org/outbound/'
    | '/$lang/orgs/$org/internal/whs/$location'
    | '/$lang/orgs/$org/outbound/whs/$location'
    | '/$lang/orgs/$org/internal/whs/$location/ftp'
    | '/$lang/orgs/$org/internal/whs/$location/ftp-config'
    | '/$lang/orgs/$org/internal/whs/$location/home'
    | '/$lang/orgs/$org/outbound/whs/$location/items'
    | '/$lang/orgs/$org/outbound/whs/$location/locations'
    | '/$lang/orgs/$org/outbound/whs/$location/selectors'
    | '/$lang/orgs/$org/outbound/whs/$location/user-groups'
    | '/$lang/orgs/$org/outbound/whs/$location/zones'
    | '/$lang/orgs/$org/internal/whs/$location/'
    | '/$lang/orgs/$org/outbound/whs/$location/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks'
    | '/$lang/orgs/$org/internal/whs/$location/selector-sessions/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new'
    | '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans/'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task/'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/all/'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/plans/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$lang'
    | '/$lang/auth/login'
    | '/$lang/auth/redirect'
    | '/$lang/auth/reset-password'
    | '/$lang/orgs/$org/analytics'
    | '/$lang/orgs/$org'
    | '/$lang/orgs/$org/internal'
    | '/$lang/orgs/$org/outbound'
    | '/$lang/orgs/$org/internal/whs/$location/ftp'
    | '/$lang/orgs/$org/internal/whs/$location/ftp-config'
    | '/$lang/orgs/$org/internal/whs/$location/home'
    | '/$lang/orgs/$org/outbound/whs/$location/items'
    | '/$lang/orgs/$org/outbound/whs/$location/locations'
    | '/$lang/orgs/$org/outbound/whs/$location/selectors'
    | '/$lang/orgs/$org/outbound/whs/$location/user-groups'
    | '/$lang/orgs/$org/outbound/whs/$location/zones'
    | '/$lang/orgs/$org/internal/whs/$location'
    | '/$lang/orgs/$org/outbound/whs/$location'
    | '/$lang/orgs/$org/internal/whs/$location/selector-sessions'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new'
    | '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks'
    | '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task'
    | '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/all'
    | '/$lang/orgs/$org/outbound/whs/$location/tasks/plans'
  id:
    | '__root__'
    | '/'
    | '/$lang/_layout'
    | '/$lang/'
    | '/$lang/_layout/auth/login'
    | '/$lang/_layout/auth/redirect'
    | '/$lang/_layout/auth/reset-password'
    | '/$lang/_layout/orgs/$org/_layout'
    | '/$lang/_layout/orgs/$org/_layout/analytics'
    | '/$lang/_layout/orgs/$org/_layout/internal'
    | '/$lang/_layout/orgs/$org/_layout/outbound'
    | '/$lang/_layout/orgs/$org/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/internal/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/'
    | '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/'
    | '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LangLayoutRoute: typeof LangLayoutRouteWithChildren
  LangIndexRoute: typeof LangIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/': {
      id: '/$lang/'
      path: '/$lang'
      fullPath: '/$lang/'
      preLoaderRoute: typeof LangIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/_layout': {
      id: '/$lang/_layout'
      path: '/$lang'
      fullPath: '/$lang'
      preLoaderRoute: typeof LangLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$lang/_layout/auth/login': {
      id: '/$lang/_layout/auth/login'
      path: '/auth/login'
      fullPath: '/$lang/auth/login'
      preLoaderRoute: typeof LangLayoutAuthLoginRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/auth/redirect': {
      id: '/$lang/_layout/auth/redirect'
      path: '/auth/redirect'
      fullPath: '/$lang/auth/redirect'
      preLoaderRoute: typeof LangLayoutAuthRedirectRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/auth/reset-password': {
      id: '/$lang/_layout/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/$lang/auth/reset-password'
      preLoaderRoute: typeof LangLayoutAuthResetPasswordRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout'
      path: '/orgs/$org'
      fullPath: '/$lang/orgs/$org'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutRouteImport
      parentRoute: typeof LangLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/analytics': {
      id: '/$lang/_layout/orgs/$org/_layout/analytics'
      path: '/analytics'
      fullPath: '/$lang/orgs/$org/analytics'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutAnalyticsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal': {
      id: '/$lang/_layout/orgs/$org/_layout/internal'
      path: '/internal'
      fullPath: '/$lang/orgs/$org/internal'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound'
      path: '/outbound'
      fullPath: '/$lang/orgs/$org/outbound'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/'
      path: '/'
      fullPath: '/$lang/orgs/$org/internal/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/'
      path: '/'
      fullPath: '/$lang/orgs/$org/outbound/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout'
      path: '/whs/$location'
      fullPath: '/$lang/orgs/$org/internal/whs/$location'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout'
      path: '/whs/$location'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp'
      path: '/ftp'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/ftp'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/ftp-config'
      path: '/ftp-config'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/ftp-config'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home'
      path: '/home'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/home'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/items'
      path: '/items'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/items'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/locations'
      path: '/locations'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/locations'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/selectors'
      path: '/selectors'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/selectors'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/user-groups'
      path: '/user-groups'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/user-groups'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/zones'
      path: '/zones'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/zones'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-sessions/'
      path: '/selector-sessions'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/selector-sessions/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/'
      path: '/task-plans'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout'
      path: '/tasks'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/selector-tasks/$selectorId/'
      path: '/selector-tasks/$selectorId'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/selector-tasks/$selectorId/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/'
      path: '/task-plans/$task-plan'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/load-plans/'
      path: '/task-plans/load-plans'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/load-plans/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/'
      path: '/webhooks/endpoints'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/new'
      path: '/webhooks/endpoints/new'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/new'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/'
      path: '/'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/$task/'
      path: '/task-plans/$task-plan/$task'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/$task/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/task-plans/$task-plan/simulate/'
      path: '/task-plans/$task-plan/simulate'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/task-plans/$task-plan/simulate/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries': {
      id: '/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/webhooks/endpoints/$endpoint/deliveries'
      path: '/webhooks/endpoints/$endpoint/deliveries'
      fullPath: '/$lang/orgs/$org/internal/whs/$location/webhooks/endpoints/$endpoint/deliveries'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/all/'
      path: '/all'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks/all/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute
    }
    '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/': {
      id: '/$lang/_layout/orgs/$org/_layout/outbound/whs/$location/_layout/tasks/_layout/plans/'
      path: '/plans'
      fullPath: '/$lang/orgs/$org/outbound/whs/$location/tasks/plans/'
      preLoaderRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRouteImport
      parentRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute
    }
  }
}

interface LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute
}

const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren: LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutFtpConfigRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutHomeRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorSessionsIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsNewRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutSelectorTasksSelectorIdIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansLoadPlansIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutWebhooksEndpointsEndpointDeliveriesRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanTaskIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutTaskPlansTaskPlanSimulateIndexRoute,
  }

const LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutInternalRouteChildren {
  LangLayoutOrgsOrgLayoutInternalIndexRoute: typeof LangLayoutOrgsOrgLayoutInternalIndexRoute
  LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute: typeof LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren
}

const LangLayoutOrgsOrgLayoutInternalRouteChildren: LangLayoutOrgsOrgLayoutInternalRouteChildren =
  {
    LangLayoutOrgsOrgLayoutInternalIndexRoute:
      LangLayoutOrgsOrgLayoutInternalIndexRoute,
    LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRoute:
      LangLayoutOrgsOrgLayoutInternalWhsLocationLayoutRouteWithChildren,
  }

const LangLayoutOrgsOrgLayoutInternalRouteWithChildren =
  LangLayoutOrgsOrgLayoutInternalRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutInternalRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute
}

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren: LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutAllIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutPlansIndexRoute,
  }

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren
}

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren: LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutItemsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutLocationsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutSelectorsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutUserGroupsRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutZonesRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutTasksLayoutRouteWithChildren,
  }

const LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutOutboundRouteChildren {
  LangLayoutOrgsOrgLayoutOutboundIndexRoute: typeof LangLayoutOrgsOrgLayoutOutboundIndexRoute
  LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute: typeof LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren
}

const LangLayoutOrgsOrgLayoutOutboundRouteChildren: LangLayoutOrgsOrgLayoutOutboundRouteChildren =
  {
    LangLayoutOrgsOrgLayoutOutboundIndexRoute:
      LangLayoutOrgsOrgLayoutOutboundIndexRoute,
    LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRoute:
      LangLayoutOrgsOrgLayoutOutboundWhsLocationLayoutRouteWithChildren,
  }

const LangLayoutOrgsOrgLayoutOutboundRouteWithChildren =
  LangLayoutOrgsOrgLayoutOutboundRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutOutboundRouteChildren,
  )

interface LangLayoutOrgsOrgLayoutRouteChildren {
  LangLayoutOrgsOrgLayoutAnalyticsRoute: typeof LangLayoutOrgsOrgLayoutAnalyticsRoute
  LangLayoutOrgsOrgLayoutInternalRoute: typeof LangLayoutOrgsOrgLayoutInternalRouteWithChildren
  LangLayoutOrgsOrgLayoutOutboundRoute: typeof LangLayoutOrgsOrgLayoutOutboundRouteWithChildren
  LangLayoutOrgsOrgLayoutIndexRoute: typeof LangLayoutOrgsOrgLayoutIndexRoute
}

const LangLayoutOrgsOrgLayoutRouteChildren: LangLayoutOrgsOrgLayoutRouteChildren =
  {
    LangLayoutOrgsOrgLayoutAnalyticsRoute:
      LangLayoutOrgsOrgLayoutAnalyticsRoute,
    LangLayoutOrgsOrgLayoutInternalRoute:
      LangLayoutOrgsOrgLayoutInternalRouteWithChildren,
    LangLayoutOrgsOrgLayoutOutboundRoute:
      LangLayoutOrgsOrgLayoutOutboundRouteWithChildren,
    LangLayoutOrgsOrgLayoutIndexRoute: LangLayoutOrgsOrgLayoutIndexRoute,
  }

const LangLayoutOrgsOrgLayoutRouteWithChildren =
  LangLayoutOrgsOrgLayoutRoute._addFileChildren(
    LangLayoutOrgsOrgLayoutRouteChildren,
  )

interface LangLayoutRouteChildren {
  LangLayoutAuthLoginRoute: typeof LangLayoutAuthLoginRoute
  LangLayoutAuthRedirectRoute: typeof LangLayoutAuthRedirectRoute
  LangLayoutAuthResetPasswordRoute: typeof LangLayoutAuthResetPasswordRoute
  LangLayoutOrgsOrgLayoutRoute: typeof LangLayoutOrgsOrgLayoutRouteWithChildren
}

const LangLayoutRouteChildren: LangLayoutRouteChildren = {
  LangLayoutAuthLoginRoute: LangLayoutAuthLoginRoute,
  LangLayoutAuthRedirectRoute: LangLayoutAuthRedirectRoute,
  LangLayoutAuthResetPasswordRoute: LangLayoutAuthResetPasswordRoute,
  LangLayoutOrgsOrgLayoutRoute: LangLayoutOrgsOrgLayoutRouteWithChildren,
}

const LangLayoutRouteWithChildren = LangLayoutRoute._addFileChildren(
  LangLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LangLayoutRoute: LangLayoutRouteWithChildren,
  LangIndexRoute: LangIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
